import { render, staticRenderFns } from "./bindPhone.vue?vue&type=template&id=3a13ed66&scoped=true"
import script from "./bindPhone.vue?vue&type=script&lang=ts"
export * from "./bindPhone.vue?vue&type=script&lang=ts"
import style0 from "./bindPhone.vue?vue&type=style&index=0&id=3a13ed66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a13ed66",
  null
  
)

export default component.exports